import { Injectable } from '@jack-henry/frontend-utils/di';
import { NavigationsClient } from '@treasury/api/channel';

export interface NavigationOption {
    description?: string;
    key: string;
    name: string;
    path?: string;
    subMenus: NavigationOption[];
}

export enum NavigationItem {
    Accounts = 'accounts',
    Ach = 'ach',
    AchRecipientActivity = 'recipientActivity',
    AchReturnActivity = 'achReturnNacha',
    AchTemplatesList = 'batchList',
    Admin = 'admin',
    BillPay = 'billPay',
    Loans = 'loanPaymentList',
    AccountReconciliation = 'accountReconciliation',
    Reports = 'ir',
    PosPay = 'arp',
    PosPayAchExceptions = 'achExceptionsList',
    PosPayCheckExceptions = 'arpExceptionsList',
    StopPayment = 'stp',
    Transfers = 'transfer',
    Wires = 'wire',
    WiresFX = 'createFXWire',
}

export const flattenNavigationOptions = (navigations: NavigationOption[]) =>
    navigations
        .map((menu: NavigationOption) => {
            const navKey = menu.key;
            const mainKeys = menu.subMenus.map((submenu: NavigationOption) => submenu.key);
            const subKeys = menu.subMenus.map((submenu: NavigationOption) =>
                submenu.subMenus.map((sub: NavigationOption) => sub.key)
            );
            return [navKey, ...mainKeys, ...subKeys.flat()];
        })
        .flat();

@Injectable()
export class NavigationsService {
    constructor(private readonly navigationsClient: NavigationsClient) {}

    public async getNavigationOptions() {
        const response = await this.navigationsClient.navigationsGet();
        return response.data;
    }

    public async getFlattenedNavigationOptions() {
        const response = await this.navigationsClient.navigationsGet({ maxAgeInSeconds: 30 });
        const navigations = response.data;
        return flattenNavigationOptions(navigations as NavigationOption[]);
    }
}
